import React from 'react';
import { DefaultTheme } from '@monorepo-web/styles';
import { CardsResumoCarteiraPDF, GraficoAlocacaoPDF, GraficoEvolucaoPatrimonioPDF, GraficoGanhoFinanceiroPDF, GraficoRetornoAcumuladoPDF } from '@monorepo-web/templates';
import { IPageData } from '../Pages/IPageData';
import { IPreferenceCustomizacao } from '@monorepo-web/logic-extrato';
import { docJSPDF, IConfig } from '@monorepo-web/pdf-generator';

/**
 * Gera objeto com os componentes React dos gráficos utilizados no PDF
 * @param pageData Dados das páginas
 * @param theme Tema
 * @param configs Objeto com as configurações de cada componente disponível
 * @param sendComponent Função que envia o SVG do gráfico quando termina de a animação
 * @param preferenceCustomizacao Customizações
 * @param moneyPrefix Unidade monetária
 *
 * @returns Componentes React com os gráficos que serão utilizados no PDF
 */
export function gerarGraficos(pageData: IPageData, theme: DefaultTheme, docObj: docJSPDF, configs: Record<string, IConfig>, sendComponent: (id: string, html: any) => void, preferenceCustomizacao: IPreferenceCustomizacao | null, moneyPrefix: string) {
  if (!pageData) return null;
  const graficos: Record<string, React.ReactNode> = {
    'Cards':
      <CardsResumoCarteiraPDF
        id='Cards'
        data={pageData.ResCart?.resumo}
        config={configs.Cards}
        sendComponent={sendComponent}
        moneyPrefix={moneyPrefix}
        replaceLabelCards={{
          saldo1: preferenceCustomizacao?.ResCart_textoCard1,
          saldo2: preferenceCustomizacao?.ResCart_textoCard5,
        }}
      />,
    'graficoClasse': <GraficoAlocacaoPDF
      id='graficoClasse'
      titulo='Alocação por Classe'
      docObj={docObj}
      data={pageData.ResCart?.pieChartClassData}
      config={configs.graficoClasse}
      sendComponent={sendComponent}
      theme={theme}
      layout={preferenceCustomizacao?.ResCart_ClasseIsHorizontal ? 'barra' : 'default'}
    />,
    'graficoCustodiante': <GraficoAlocacaoPDF
      id='graficoCustodiante'
      titulo='Alocação por Custodiante'
      docObj={docObj}
      data={pageData.ResCart?.pieChartCustodianteData}
      config={configs.graficoCustodiante}
      sendComponent={sendComponent}
      theme={theme}
      moneyPrefix={moneyPrefix}
      layout={
        preferenceCustomizacao?.ResCart_CustodianteIsHorizontal ?
          'barra' :
          preferenceCustomizacao?.ResCart_graficoAlocacaoVolume ? 'custodiante_monetary' : 'default'
      }
    />,
    'EvolucaoPatrimonio': <GraficoEvolucaoPatrimonioPDF
      docObj={docObj}
      data={pageData.PerfHist?.dataEvol}
      config={configs.EvolucaoPatrimonio}
      sendComponent={sendComponent}
      theme={theme}
      moneyPrefix={moneyPrefix}
    />,
    'RetornoAcumulado': <GraficoRetornoAcumuladoPDF
      docObj={docObj}
      data={pageData.PerfHist?.data}
      assetsApi={pageData.PerfHist?.assetsApi}
      config={configs.RetornoAcumulado}
      sendComponent={sendComponent}
      theme={theme}
      layout={preferenceCustomizacao?.PerfHist_retornoAcumuladoTopo ? 'full_width' : 'default'}
    />,
    'GanhoFinanceiro': <GraficoGanhoFinanceiroPDF
      docObj={docObj}
      data={pageData.PerfHist?.barChartRend12Data}
      config={configs.GanhoFinanceiro}
      sendComponent={sendComponent}
      theme={theme}
      moneyPrefix={moneyPrefix}
    />,
    'alocacaoCarteiraExplodida': <GraficoAlocacaoPDF
      id='alocacaoCarteiraExplodida'
      docObj={docObj}
      data={pageData.CartExp?.pieChartClasseData}
      aviso_carteira_explodida={pageData.CartExp?.aviso_carteira_explodida}
      obj_datas={pageData.CartExp?.obj_datas}
      config={configs.alocacaoCarteiraExplodida}
      sendComponent={sendComponent}
      theme={theme}
      layout='carteira_explodida'
    />
  }

  // seleciona os elementos HTML e os gráficos listados no PDF
  const graficosFilter: Record<string, React.ReactNode> =
    Object.entries(graficos)
      .filter(([graficoKey]) => configs[graficoKey])
      .reduce((acc, [key, component]) => {
        acc[key] = component;
        return acc;
      }, {} as Record<string, React.ReactNode>);

  return graficosFilter;
}
